import AccountSettings from './AccountSettings'

export {default as ChangeEmail} from './ChangeEmail'
export {default as ChangePassword} from './ChangePassword'
export {default as DeleteAccount} from './DeleteAccount'
export default AccountSettings
